import { useState } from 'react'
import { useQuery } from 'react-query'

import { QueryKeys } from '../../../enums/queryKeys'
import { useOrganizationSource } from '../../../hooks'
import { ExternalInvoicesSyncStatus } from '../enums/externalInvoicesSyncStatus'
import { fetchExternalInvoicesSync } from '../query-api'

const SYNC_REFETCH_INTERVAL = 60000 // 1 minute

export const useFetchExternalInvoicesSync = () => {
  const [shouldRefetch, setShouldRefetch] = useState(false)
  const { isSourceZervant } = useOrganizationSource()

  const { data, ...rest } = useQuery(QueryKeys.ExternalInvoicesSync, () => fetchExternalInvoicesSync(), {
    enabled: isSourceZervant,
    onSuccess: (data) => {
      const syncStatus = data?.data?.syncStatus
      const isSyncInProgress = syncStatus === ExternalInvoicesSyncStatus.InProgress

      setShouldRefetch(isSyncInProgress)
    },
    refetchInterval: shouldRefetch ? SYNC_REFETCH_INTERVAL : false,
    refetchIntervalInBackground: true,
    refetchOnWindowFocus: false,
  })

  return { syncData: data?.data, ...rest }
}
